// Auto-extracted verbatim from coach-oj-landing.html (design unchanged).
export const BODY_HTML = `<div id="progress"></div>
<nav>
  <div class="wrap">
    <div class="mark">Coach&nbsp;<span>OJ</span></div>
    <div class="nav-right">
      <div class="lang" role="group" aria-label="Language">
        <button class="lang-opt" data-lang="ar">AR</button><span class="lang-sep">/</span><button class="lang-opt is-active" data-lang="en">EN</button><span class="lang-sep">/</span><button class="lang-opt" data-lang="fr">FR</button>
      </div>
      <a href="#contact" class="btn btn-primary desktop-cta js-book magnetic" data-i18n="nav_cta">Book a call</a>
    </div>
  </div>
</nav>

<header id="hero">
  <div class="aurora"><span class="glow"></span><b></b><b></b><b></b></div>
  <div class="wrap hero-grid">
    <div class="hero-copy">
      <div class="eyebrow hero-eyebrow reveal" data-i18n="hero_eyebrow">Habit &amp; lifestyle coaching</div>
      <h1 class="reveal" data-i18n-html="hero_h1">Break the habits keeping you stuck. Build a life that <span class="em">actually holds.</span></h1>
      <p class="hero-sub reveal" data-i18n="hero_sub">I help you spot the self-sabotage running quietly underneath everything — then rebuild, one realistic step at a time, in a way that fits your real life instead of an ideal one.</p>
      <div class="hero-cta reveal">
        <a href="#contact" class="btn btn-primary js-book magnetic" data-i18n="cta_book">Book a free intro call</a>
        <a href="#how" class="btn btn-ghost" data-i18n="cta_how">See how I work</a>
      </div>
      <div class="langs reveal" data-i18n-html="hero_langs">Coaching in <b>English</b> · <b>العربية</b> · <b>Français</b></div>
    </div>
    <div class="hero-art reveal">
      <img class="hero-cut" src="/assets/coach-cutout.png" alt="Coach OJ — Omar Jannoun">
      <span class="plus p1" data-depth="4">+</span><span class="plus c p2" data-depth="6">+</span><span class="plus m p3" data-depth="5">+</span>
    </div>
  </div>
</header>

<div class="marquee" aria-hidden="true">
  <div class="marquee-track">
    <span data-i18n="mq1">Meet you where you are</span><span data-i18n="mq2">One pattern first</span><span data-i18n="mq3">Sustainable, not heroic</span><span data-i18n="mq4">Built to set you free</span><span data-i18n="mq5">Consistency beats intensity</span><span data-i18n="mq6">Honest, not harsh</span><span data-i18n="mq7">Small enough to keep</span><span data-i18n="mq8">Strong enough for bad weeks</span><span data-i18n="mq9">Not motivation. Structure.</span><span data-i18n="mq10">Real weeks, not perfect ones</span><span data-i18n="mq11">Depth over hacks</span><span data-i18n="mq12">Start small. Finish strong.</span><span data-i18n="mq1">Meet you where you are</span><span data-i18n="mq2">One pattern first</span><span data-i18n="mq3">Sustainable, not heroic</span><span data-i18n="mq4">Built to set you free</span><span data-i18n="mq5">Consistency beats intensity</span><span data-i18n="mq6">Honest, not harsh</span><span data-i18n="mq7">Small enough to keep</span><span data-i18n="mq8">Strong enough for bad weeks</span><span data-i18n="mq9">Not motivation. Structure.</span><span data-i18n="mq10">Real weeks, not perfect ones</span><span data-i18n="mq11">Depth over hacks</span><span data-i18n="mq12">Start small. Finish strong.</span>
  </div>
</div>

<section class="story">
  <div class="wrap story-grid">
    <div class="reveal">
      <div class="eyebrow" data-i18n="story_eyebrow">Why me</div>
      <h2 style="font-size:clamp(1.8rem,4vw,2.7rem);margin:14px 0 22px" data-i18n="story_h2">I've actually walked this road.</h2>
      <p data-i18n="story_p1">I'm not coaching from a textbook. I've clawed my way out of my own ruts, rebuilt my habits from the ground up, quit social media for good, and put myself through a serious physical and lifestyle transformation.</p>
      <p data-i18n="story_p2">So I know — from the inside — what "realistic" actually looks like. I won't hand you some overwhelming ten-step plan that looks impressive and collapses by Wednesday. I meet you exactly where you are, find the one pattern doing the most damage, and we start there.</p>
      <p class="muted" style="font-size:.95rem" data-i18n="story_p3">Trained through the Achology-accredited life coach program (Kain Ramsay). ICF credentialing on the way.</p>
    </div>
    <div class="reveal">
      <div class="photo-duo">
        <figure class="photo"><span class="tag" data-i18n="tag_before">Before</span><img src="/assets/before.jpg" alt="Omar Jannoun before his transformation" loading="lazy"></figure>
        <figure class="photo"><span class="tag after" data-i18n="tag_after">After</span><img src="/assets/after.jpg" alt="Omar Jannoun after his transformation" loading="lazy"></figure>
      </div>
    </div>
  </div>
</section>

<section class="origin">
  <div class="wrap">
    <div class="sec-head reveal" style="max-width:680px">
      <div class="eyebrow" data-i18n="origin_eyebrow">The long way round</div>
      <h2 data-i18n="origin_h2">How I actually got here.</h2>
    </div>
    <div class="origin-body reveal" data-i18n-html="origin_body"><p>I didn't end up there overnight.</p><p>It was years of small bad decisions all coming due at once. By the end I had no plans, only wishful thinking. Addictions I won't detail here. Friends cut me off, and I cut off the ones who hadn't. I went quiet in the way people go quiet when they've stopped expecting anything.</p><p>The weight came later, by the way. At my lowest I was thin — and thin wasn't healthy, it just photographed better. That's the part most people have backwards. <b>The body is the last thing to change, not the first.</b></p><p>What was actually running the whole thing was simpler and uglier: I was avoiding my life. Numbing it, dodging the consequences, hoping the mess would somehow sort itself out if I looked away long enough. It doesn't. It compounds.</p><p>And the worst part wasn't the state I was in. It was being certain that nobody had ever felt this, and nobody ever could. That belief keeps you alone, and alone is where it gets worse.</p><p>I was wrong about that. What I needed wasn't someone who had lived my exact hell — <b>it was to be understood.</b> Those are not the same thing, and finding that out changed everything. The right people. The right professionals. The right conversations. Lives nothing like mine, and it didn't matter at all.</p><p>Through all of it I never fully let go of one small thing. Call it hope, call it faith, call it stubbornness — a grain of it, no more. <b>In a dark enough room, a grain is enough to move by.</b></p><p>Then came the crossroads. Standing there, I understood that mediocre was off the menu — it was going all the way down, or all the way up. I'd relapsed more times than I can count getting to that point. I picked up anyway.</p><p>It took years. Not weeks. And I'd gone a long way in the wrong direction first.</p><p>The guidance I needed was never one thing, and it was never clinical. It was my relationships, and how badly I communicated inside them. My self-worth, and the sense of direction I'd stopped believing I had. Work, and what I actually wanted from a career. Nutrition, sleep, movement — the unglamorous lifestyle mechanics that decide how much energy you get in a day. The habits that had their hooks in me. The ruts I couldn't see the walls of.</p><p>Nobody handed me a motivational speech or a ten-step plan. Someone helped me find the one pattern doing the most damage, then build something realistic on top of it — structure and accountability sized to my actual life, not an ideal one. That's the same ground I coach on now.</p><p>I'm not perfect now and I never will be. What I have is different: I know how to fall and get myself back up — sometimes alone, sometimes with the guidance I went far too long without. I know what's realistic and what's fantasy, what's sustainable and what burns out, when to hold myself to account and when to give myself room.</p><p>Not perfectionism. Balance — built inside first, then carried out.</p><p>Everything I know was handed to me by people I met along the way, from all over the world. It cost me a lifetime to learn. Passing it on doesn't feel like a business. <b>It feels like something I owe.</b></p></div>
  </div>
</section>

<section id="how">
  <div class="wrap">
    <div class="sec-head reveal">
      <div class="eyebrow" data-i18n="how_eyebrow">How I work</div>
      <h2 data-i18n="how_h2">Four things I do differently.</h2>
    </div>
    <div class="grid4 reveal">
      <div class="cell"><span class="n">01</span><h3 data-i18n="p1_h">Meet you where you are</h3><p data-i18n="p1_p">No judgment, no pretending you're further along — or further gone — than you really are. We start from the truth.</p></div>
      <div class="cell"><span class="n">02</span><h3 data-i18n="p2_h">One pattern first</h3><p data-i18n="p2_p">We find the single habit doing the most damage and begin there. Not everywhere at once. That's why it sticks.</p></div>
      <div class="cell"><span class="n">03</span><h3 data-i18n="p3_h">Sustainable, not heroic</h3><p data-i18n="p3_p">Every step is sized to your actual context, so it lasts past the first burst of motivation instead of burning out in a week.</p></div>
      <div class="cell"><span class="n">04</span><h3 data-i18n="p4_h">Built to set you free</h3><p data-i18n="p4_p">My goal is to make you independent. I'm not here to keep you coming back forever — I want you running your own life by the end.</p></div>
    </div>
  </div>
</section>

<section class="proof">
  <div class="wrap">
    <figure class="qotd reveal">
      <div class="eyebrow qotd-eyebrow" data-i18n="proof_eyebrow">Quote of the day</div>
      <blockquote class="qotd-text" id="qotdText">Loading…</blockquote>
      <figcaption class="qotd-by" id="qotdBy"></figcaption>
    </figure>
  </div>
</section>

<section class="loop">
  <div class="wrap loop-grid">
    <div class="reveal">
      <div class="eyebrow" data-i18n="loop_eyebrow">If this sounds familiar</div>
      <blockquote style="margin-top:22px" data-i18n-html="loop_quote">You start strong on Monday — new plan, real motivation. By Wednesday you're back where you began, telling yourself you'll restart next week. <span class="em">The problem was never willpower.</span> It's that the plan never fit your real life, and nobody helped you see the pattern running the whole thing.</blockquote>
    </div>
  </div>
</section>

<section id="offer">
  <div class="wrap">
    <div class="sec-head reveal">
      <div class="eyebrow" data-i18n="offer_eyebrow">Ways to work together</div>
      <h2 data-i18n="offer_h2">Pick the depth that fits you.</h2>
    </div>

    <!-- FUNNEL A: free discovery call (20 min). [BUILD] books a 20-min intro slot, NO Stripe. -->
    <div class="fitcall reveal">
      <div>
        <div class="fc-l" data-i18n-html="fit_l">Not sure yet? Book a <b>free 20-min discovery call.</b></div>
        <div class="fc-s" data-i18n="fit_s">A quick chat to see if we click — no coaching, no pressure.</div>
      </div>
      <a href="#contact" class="btn btn-ghost js-book" data-plan="Fit Call" data-i18n="fit_btn">Book the free call</a>
    </div>

    <!-- FUNNEL B: paid tiers. [BUILD] each -> slot -> Stripe Checkout -> Supabase booking. -->
    <div class="cards reveal">
      <div class="card tilt">
        <h3 data-i18n="plan1_name">Single Session</h3>
        <div class="price" data-i18n="plan1_price">$59</div><div class="per" data-i18n="plan1_per">one 50-min session · $59</div>
        <ul>
          <li data-i18n="plan1_l1">One focused 1:1 video session (50 min)</li>
          <li data-i18n="plan1_l2">Honest read on where you actually are</li>
          <li data-i18n="plan1_l3">We name your #1 self-sabotage pattern</li>
          <li data-i18n="plan1_l4">One realistic first step to act on now</li>
        </ul>
        <a href="#contact" class="btn btn-ghost js-book" data-plan="Single Session" data-i18n="plan1_btn">Book a session</a>
      </div>
      <div class="card feat tilt" data-badge="Recommended">
        <h3 data-i18n="plan2_name">30-Day Program</h3>
        <div class="price" data-i18n="plan2_price">$169</div><div class="per" data-i18n="plan2_per">4 sessions · $42 each</div>
        <ul>
          <li data-i18n="plan2_l1">4 weekly 50-min 1:1 sessions</li>
          <li data-i18n="plan2_l2">Your personalized habit system</li>
          <li data-i18n="plan2_l3">WhatsApp check-ins (Mon–Fri, 24h replies)</li>
          <li data-i18n="plan2_l4">A relapse / setback game-plan</li>
        </ul>
        <a href="#contact" class="btn btn-clay js-book" data-plan="30-Day Program" data-i18n="plan2_btn">Start the 30 days</a>
      </div>
      <div class="card tilt">
        <h3 data-i18n="plan3_name">90-Day Program</h3>
        <div class="price" data-i18n="plan3_price">$439</div><div class="per" data-i18n="plan3_per">12 sessions · $37 each</div>
        <ul>
          <li data-i18n="plan3_l1">Everything in the 30-Day, extended &amp; deeper</li>
          <li data-i18n="plan3_l2">12 sessions across 3 months</li>
          <li data-i18n="plan3_l3">Priority WhatsApp access (Mon–Fri)</li>
          <li data-i18n="plan3_l4">Mid-point deep review + end-of-program tune-up</li>
        </ul>
        <a href="#contact" class="btn btn-ghost js-book" data-plan="90-Day Program" data-i18n="plan3_btn">Go all in</a>
      </div>
    </div>

    <p class="intro-note reveal" data-i18n="intro_note">Still weighing up which one fits? Book the free intro call — no pressure, no pitch. We'll talk it through and find your starting point.</p>
    <p class="hardship reveal"><span data-i18n="hardship_note">On a tight budget but serious about changing? I keep a few reduced places.</span> <button type="button" class="linklike js-apply" data-i18n="hardship_cta">Ask about one</button></p>
    <p class="capnote" data-i18n="cap_note">I'm at capacity right now — join the waitlist below and you're first in line.</p>
  </div>
</section>

<section class="creds">
  <div class="wrap creds-grid reveal">
    <div><span class="eyebrow" data-i18n="cred1_e">Training</span><p data-i18n-html="cred1_p">Achology-accredited<br>life coach program</p></div>
    <div><span class="eyebrow" data-i18n="cred2_e">Approach</span><p data-i18n-html="cred2_p">Honest, grounded,<br>built to last</p></div>
    <div><span class="eyebrow" data-i18n="cred3_e">Languages</span><p>English · العربية<br>Français</p></div>
  </div>
</section>

<section class="dips">
  <div class="wrap">
    <div class="sec-head reveal" style="max-width:680px">
      <div class="eyebrow" data-i18n="dip_eyebrow">Always learning</div>
      <h2 data-i18n="dip_h2">Backed by real, ongoing study.</h2>
      <p class="muted" style="margin-top:14px" data-i18n="dip_sub">A few of the certifications behind the work — with more on the way.</p>
    </div>
  </div>
  <div class="cert-carousel">
    <div class="cert-track">
      <figure class="cert-card"><img src="/assets/cert-nutrition.jpg" alt="Certificate in Nutrition — Fabulous Body"><figcaption class="cert-cap" data-i18n="dip_cap1">Certificate in Nutrition — Fabulous Body (NASM-approved CEUs)</figcaption></figure>
      <figure class="cert-card"><img src="/assets/cert-harvard.jpg" alt="Harvard Medical School Executive Education"><figcaption class="cert-cap" data-i18n="dip_cap2">Harvard Medical School Executive Education — Health &amp; Wellness</figcaption></figure>
      <figure class="cert-card"><img src="/assets/cert-lifecoaching.jpg" alt="Advanced Certification in Life Coaching"><figcaption class="cert-cap" data-i18n="dip_cap3">Advanced Certification in Life Coaching — Academy of Modern Applied Psychology (in progress)</figcaption></figure>
      
      
      
    </div>
  </div>
  <p class="cert-more" data-i18n="dip_more">More certifications on the way</p>
  <span class="plus dp1">+</span><span class="plus c dp2">+</span><span class="plus m dp3">+</span><span class="plus dp4">+</span>
</section>

<section id="faq">
  <div class="wrap" style="max-width:860px">
    <div class="sec-head reveal">
      <div class="eyebrow" data-i18n="faq_eyebrow">Before you reach out</div>
      <h2 data-i18n="faq_h2">Straight answers.</h2>
    </div>
    <div class="reveal">
      <details><summary data-i18n="faq_q1">Are you a therapist or counselor?</summary><p data-i18n="faq_a1">No — this is coaching. It's forward-looking and practical: goals, habits, accountability, and mindset. If you're dealing with a clinical mental-health condition, coaching isn't a substitute for therapy, and I'll tell you honestly if that's what I'm hearing.</p></details>
      <details><summary data-i18n="faq_q2">What if I don't know exactly what my problem is?</summary><p data-i18n="faq_a2">Totally normal. The first session is partly about figuring that out together — naming the real pattern instead of guessing at it.</p></details>
      <details><summary data-i18n="faq_q3">Do I have to commit long-term?</summary><p data-i18n="faq_a3">No — the opposite. I build everything to get you standing on your own as fast as realistically possible. No forever-contracts, no manufactured dependency.</p></details>
      <details><summary data-i18n="faq_q4">What if I fall off or relapse partway through?</summary><p data-i18n="faq_a4">Expected, not a failure. Setbacks are part of real change — we plan for them in advance so they don't derail you. The 30-Day Program includes a dedicated game-plan for exactly this.</p></details>
      <details><summary data-i18n="faq_q5">How do we actually meet?</summary><p data-i18n="faq_a5">Over video call, in English, Arabic, or French — whichever you're most comfortable in.</p></details>
    </div>
  </div>
</section>

<section class="final" id="contact">
  <div class="wrap reveal">
    <span class="plus fp1">+</span><span class="plus fp2">+</span>
    <div class="eyebrow" style="color:#dbeafb" data-i18n="final_eyebrow">The first step</div>
    <h2 style="margin-top:16px" data-i18n="final_h2">Tell me where you're stuck.</h2>
    <p data-i18n="final_p">Send me a couple of honest lines about what you want to change. I'll tell you straight whether I'm the right person to help — no pressure either way.</p>
    <a href="#contact" class="btn btn-primary js-book magnetic" data-i18n="cta_book">Book a free intro call</a>
    <a href="https://wa.me/33624358117" class="btn btn-ghost js-wa" data-i18n="final_wa">Message on WhatsApp</a>
    <a href="mailto:Contact@coachoj.com" class="btn btn-ghost" data-i18n="final_email">Email me</a>
  </div>
</section>

<section class="terms" id="terms">
  <div class="wrap reveal">
    <span class="eyebrow" data-i18n="terms_e">Before you book</span>
    <h2 data-i18n="terms_h">How cancellations and refunds work</h2>
    <ul class="terms-list">
      <li data-i18n="terms_1">The first call is free. Nothing is charged before we have spoken.</li>
      <li data-i18n="terms_2">Move or cancel a session up to 24 hours beforehand at no cost, using the link in your confirmation email.</li>
      <li data-i18n="terms_3">Cancel with less than 24 hours' notice and the session counts as used.</li>
      <li data-i18n="terms_4">On a programme, sessions you have not yet had are refundable at any time, pro rata.</li>
      <li data-i18n="terms_5">A session already delivered is not refundable — but if something went wrong, write to me and I will make it right.</li>
      <li data-i18n="terms_6">Coaching is not therapy or medical care, and no particular outcome is promised.</li>
    </ul>
    <p class="terms-foot" data-i18n="terms_foot">Questions before you commit? Book the free call, or write to contact@coachoj.com.</p>
  </div>
</section>

<footer>
  <div class="wrap">
    <div class="mark">Coach&nbsp;<span style="color:var(--clay)">OJ</span></div>
    <div data-i18n="footer_tag">Habit &amp; lifestyle coaching · English · Arabic · French</div>
    <div style="margin-top:6px;opacity:.7" id="rights">© <span id="yr"></span> Coach OJ. All rights reserved.</div>
    <div class="footer-links"><a href="#terms" data-i18n="footer_terms">Cancellations and refunds</a> &middot; <a href="/privacy/" data-i18n="footer_privacy">Privacy</a></div>
  </div>
</footer>

<div class="modal" id="bookModal" aria-hidden="true">
  <div class="sheet" role="dialog" aria-modal="true" aria-labelledby="bkTitle">
    <div class="sheet-head">
      <button class="sheet-close" id="bkClose" aria-label="Close">×</button>
      <h3 id="bkTitle" data-i18n="bk_title">Book your intro call</h3>
      <p data-i18n="bk_sub">Pick a day and time that works — I'll confirm by message.</p>
    </div>
    <div class="sheet-body" id="bkBody">
      <div class="plan-pick" id="bkPlans"></div>
      <div id="bkStep1">
        <div class="bk-contact">
          <div class="bk-field"><label data-i18n="bk_name">Your name</label><input id="bkName" type="text" autocomplete="name" placeholder=""></div>
          <div class="bk-field"><label data-i18n="bk_email">Email</label><input id="bkEmail" type="email" autocomplete="email" placeholder=""></div>
          <div class="bk-field"><label data-i18n="bk_note">A line about what you want to change (optional)</label><textarea id="bkNote" rows="2"></textarea></div>
        </div>
        <div class="bk-code">
          <button type="button" class="linklike" id="bkCodeToggle" data-i18n="bk_code_toggle">I have a code</button>
          <div class="bk-code-row" id="bkCodeRow" hidden>
            <input id="bkCode" type="text" autocomplete="off" spellcheck="false" maxlength="16" placeholder="ABCD2345">
            <button type="button" class="btn btn-ghost" id="bkCodeApply" data-i18n="bk_code_apply">Apply</button>
          </div>
          <p class="bk-code-msg" id="bkCodeMsg" hidden></p>
        </div>
        <div class="sheet-foot">
          <button class="btn btn-clay" id="bkConfirm" disabled data-i18n="bk_confirm">Choose your time</button>
        </div>
      </div>
      <div id="bkStep2" hidden>
        <button class="bk-back" id="bkBack" type="button" data-i18n="bk_back">← Back to your details</button>
        <div id="bkCal" class="bk-cal"></div>
        <div class="bk-cal-fallback" id="bkCalFallback" hidden data-i18n="bk_cal_fallback">The calendar could not load. Please check your connection, or message me on WhatsApp and I'll book you in directly.</div>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="applyModal" aria-hidden="true">
  <div class="sheet" role="dialog" aria-modal="true" aria-labelledby="apTitle">
    <div class="sheet-head">
      <button class="sheet-close" id="apClose" aria-label="Close">×</button>
      <h3 id="apTitle" data-i18n="ap_title">Ask about a reduced place</h3>
      <p data-i18n="ap_sub">Tell me where you are. I read every one of these myself.</p>
    </div>
    <div class="sheet-body" id="apBody">
      <div class="bk-contact">
        <div class="bk-field"><label data-i18n="bk_name">Your name</label><input id="apName" type="text" autocomplete="name"></div>
        <div class="bk-field"><label data-i18n="bk_email">Email</label><input id="apEmail" type="email" autocomplete="email"></div>
        <div class="bk-field"><label data-i18n="ap_msg">What you are working on, and what you could manage</label><textarea id="apMsg" rows="4"></textarea></div>
      </div>
      <div class="sheet-foot">
        <button class="btn btn-clay" id="apSend" disabled data-i18n="ap_send">Send it</button>
      </div>
    </div>
  </div>
</div>
<div class="toast" id="toast"></div>`;
